import { breakpoints } from "@certn/cascadia-tokens";
import { PopoverProps } from "react-aria-components";
import { useMediaQuery } from "usehooks-ts";

import { _Popover } from "./_Popover";
import { Modal } from "../modal/Modal";

interface Props {
  isOpen: boolean;
  onOpenChange(isOpen: boolean): void;
  isDismissable?: boolean;
  popoverPlacement?: PopoverProps["placement"];
  popoverMinWidth?: string | number;
  popoverMaxWidth?: string;
  children?: React.ReactNode;
}

/**
 * Works the same as Popover, but will render a Modal instead on mobile.
 */
export function _ResponsivePopover(props: Props) {
  const isMobile = useMediaQuery(
    `(max-width: ${breakpoints["breakpoint-sm"].maxWidth}px)`
  );

  const {
    isOpen,
    onOpenChange,
    isDismissable,
    popoverPlacement,
    popoverMinWidth,
    popoverMaxWidth,
    children,
  } = props;

  return isMobile ? (
    <Modal
      isDismissable={isDismissable}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      {children}
    </Modal>
  ) : (
    <_Popover
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      placement={popoverPlacement}
      minWidth={popoverMinWidth}
      maxWidth={popoverMaxWidth}
    >
      {children}
    </_Popover>
  );
}
